module.exports = __webpack_public_path__ + "img/Pack_enfance.fd6f88dc.jpg";